import {Hydra} from '../generic/hydra';

import {FichierInterface} from './Fichier';
import {AideTranslation as AideTranslationBaseInterface} from '../../interface/api/AideTranslation';

export type AideTranslationInterface = AideTranslationBaseInterface;

export class AideTranslation extends Hydra implements AideTranslationInterface {

    id?: number | null;

    locale?: string | null;

    commentaire?: string | null;

    preRequis?: string | null;

    annexeInformation?: string | null;

    /* Objet de la classe Fichier, avec un fichierType 'public'
     */
    notice?: any | null;

    /* fichiers de type 'public'
     */
    downloads?: FichierInterface[] | null = [];

    accroche?: string | null;


    constructor(options: AideTranslationInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
